// src/contexts/NotificationContext.js
import { createContext, useContext, useCallback } from 'react';
import {
  ToasterContainer,
  toaster,
  PLACEMENT,
  KIND
} from 'baseui/toast';

const NotificationContext = createContext(null);

export const useNotification = () => {
  return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {

  const showNotification = useCallback((message, kind = 'info') => {
    const toastKind = {
      info: KIND.info,
      success: KIND.positive,
      warning: KIND.warning,
      error: KIND.negative,
    }[kind];

    toaster.show(message, {
      kind: toastKind,
    });
  }, []);

  const value = {
    showNotification,
  };

  return (
    <NotificationContext.Provider value={value}>
      <ToasterContainer placement={PLACEMENT.topRight} autoHideDuration={5000}>
        {children}
      </ToasterContainer>
    </NotificationContext.Provider>
  );
};